import {
  CheckCircle as CheckCircleIcon,
  RadioButtonUnchecked as RadioButtonUncheckedIcon,
} from '@mui/icons-material';
import { List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import { FallbackInlay } from 'components/general/ViewPortInlay';
import Widget from 'components/general/widgets/Widget';
import { MomentContext } from 'providers';
import { useContext } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import useStyles from './styles';

const ConditionsLogicPlaybackList = () => {
  const { model } = useContext(MomentContext);
  const { classes } = useStyles();

  return (
    <List disablePadding>
      {model.Condition.all().map((condition, j) => (
        <ListItem key={condition.name} dense>
          <ListItemIcon className={classes.conditionIcon}>
            {condition.compliance ? (
              <CheckCircleIcon className={classes.activeIcon} />
            ) : (
              <RadioButtonUncheckedIcon />
            )}
          </ListItemIcon>
          <ListItemText classes={{ primary: classes.conditionName }} primary={condition.name} />
        </ListItem>
      ))}
    </List>
  );
};

const ConditionsLogicPlaybackWidget = (props) => {
  const { className } = props;
  const { classes, cx } = useStyles();
  return (
    <Widget
      maxWidth={400}
      minWidth={250}
      className={cx(className, classes.root)}
      title="Condition Compliance"
      collapsibleConfig
    >
      <ErrorBoundary
        fallback={
          <FallbackInlay
            text="This chart is under construction."
            subText="Our team is working to restore this feature."
          />
        }
      >
        <ConditionsLogicPlaybackList />
      </ErrorBoundary>
    </Widget>
  );
};

export default ConditionsLogicPlaybackWidget;
